import { Col, Row } from "reactstrap";
import { FontsTitle } from "../../../Constants/Constants";
import { FontsData } from "../../../Data/Bonus/Elements";

const Fonts = () => {
  return (
    <section className="element-span-prag">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{FontsTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {FontsData.map((item, index) => (
                <div className={`font-${item} fonts`} key={index}>font-{item}</div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Fonts;
